import { useCallback } from "react";

import { MessageKey, useT } from "@/i18n";
import { NavLinksGroupType } from "@/layouts/DashboardLayout/NavLink/NavLink.types";

const NAV_LINKS_GROUP_LABELS: { [key in NavLinksGroupType]: MessageKey } = {
  governing: "general.navigation.groups.governing",
  data: "general.navigation.groups.data",
  settings: "general.navigation.groups.settings",
  appearance: "general.navigation.groups.appearance",
  finance: "general.navigation.groups.finance",
  superData: "general.navigation.groups.superData",
  other: "general.navigation.groups.other",
};

export const useGetNavLinksGroupLabel = () => {
  const t = useT();

  const getNavLinksGroupLabel = useCallback(
    (type: NavLinksGroupType) => {
      return t(NAV_LINKS_GROUP_LABELS[type]);
    },
    [t]
  );

  return getNavLinksGroupLabel;
};
